import { render, staticRenderFns } from "./EvaluationOrganizationEvidenceJustificationModal.vue?vue&type=template&id=52078003&"
import script from "./EvaluationOrganizationEvidenceJustificationModal.vue?vue&type=script&lang=js&"
export * from "./EvaluationOrganizationEvidenceJustificationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports